'use client';

import React from 'react';

import {
  Carousel as CarouselUi,
  CarouselContent,
  CarouselItem,
  CarouselControls,
} from '@/components/ui/carousel';
import { FeatureCard } from './FeatureCard';
import { cn } from '@/utilities/cn';
import { FeaturesBlock } from '@payload-types';

export const Carousel: React.FC<FeaturesBlock> = ({
  features,
  numberAsIcon,
  columnCount,
  featuresBackgroundColor,
}) => {
  return (
    <div className="" data-name="Content">
      <CarouselUi opts={{ align: 'start' }}>
        <CarouselContent className="-ml-6">
          {features?.map((feature, idx) => (
            <CarouselItem
              className={cn(
                'flex pl-6 lg:basis-full',
                columnCount === '2' && 'basis-1/2',
                columnCount === '3' && 'basis-1/3',
                columnCount === '4' && 'basis-1/4',
              )}
              key={feature.id}
            >
              <FeatureCard
                numberAsIcon={numberAsIcon}
                featuresBackgroundColor={featuresBackgroundColor}
                index={idx}
                data={feature}
                key={feature.id}
              />
            </CarouselItem>
          ))}
        </CarouselContent>

        <CarouselControls />
      </CarouselUi>
    </div>
  );
};
